<template>
  <UMarquee class="w-full mt-12 lg:mt-18">
    <UTooltip text="Nuxt">
      <UIcon
        name="i-lineicons-nuxt"
        class="size-10"
      />
    </UTooltip>
    <UTooltip text="Symfony">
      <UIcon
        name="i-mdi-symfony"
        class="size-10"
      />
    </UTooltip>
    <UTooltip text="Drizzle">
      <UIcon
        name="i-simple-icons-drizzle"
        class="size-10"
      />
    </UTooltip>
    <UTooltip text="WordPress">
      <UIcon
        name="i-mdi-wordpress"
        class="size-10"
      />
    </UTooltip>
    <UTooltip text="Prestashop">
      <UIcon
        name="i-simple-icons-prestashop"
        class="size-10"
      />
    </UTooltip>
    <UTooltip text="Figma">
      <UIcon
        name="i-simple-icons-figma"
        class="size-10"
      />
    </UTooltip>
    <UTooltip text="Python">
      <UIcon
        name="i-simple-icons-python"
        class="size-10"
      />
    </UTooltip>
    <UTooltip text="SQL">
      <UIcon
        name="i-mdi-database"
        class="size-10"
      />
    </UTooltip>
    <UTooltip text="Tailwind CSS">
      <UIcon
        name="i-simple-icons-tailwindcss"
        class="size-10"
      />
    </UTooltip>
    <UTooltip text="Adobe Photoshop">
      <UIcon
        name="i-simple-icons-adobephotoshop"
        class="size-10"
      />
    </UTooltip>
    <UTooltip text="Adobe Illustrator">
      <UIcon
        name="i-simple-icons-adobeillustrator"
        class="size-10"
      />
    </UTooltip>
  </UMarquee>
</template>
